export default __webpack_public_path__ + "static/media/015-buoys.6ff14e05.png";